import { render } from "./personalfavorites.vue?vue&type=template&id=83626512"
import script from "./personalfavorites.vue?vue&type=script&lang=js"
export * from "./personalfavorites.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__